(()=>{
 if(window.__rnMassGuideV5)return;window.__rnMassGuideV5=true;
 // Werte entsprechen exakt der vom Shopbetreiber gelieferten Grössentabelle.
 const hips={S:[90,95],M:[95,100],L:[100,105]};
 const sizeToEU={S:'36',M:'38',L:'40'};
 const cupNames=['A','B','C','D','E','F','G'];
 const sizes=['S','M','L'];
 const apology='Für deine Kombination können wir keine sichere Grösse S–L empfehlen.';

 const root=e=>e?.closest('[data-rn-guide5]');
 const roots=()=>document.querySelectorAll('[data-rn-guide5]');
 const variantPicker=r=>document.querySelector('variant-picker[data-product-id="'+r.dataset.rnId+'"][data-template-product-match="true"]')||document.querySelector('variant-picker[data-product-id="'+r.dataset.rnId+'"]');
 const hasSize=g=>[...g.querySelectorAll('input[type="radio"],option')].some(x=>['S','M','L'].includes((x.value||'').trim().toUpperCase()));
 const optionGroups=r=>[...(variantPicker(r)?.querySelectorAll('fieldset.variant-option,div.variant-option--dropdowns')||[])].filter(hasSize);
 function group(r,kind){const gs=optionGroups(r);const match=g=>{const title=(g.querySelector('legend,label')?.textContent||'').toLowerCase();return kind==='bottom'?/höschen|string|slip|unterteil/.test(title):/bh|cup|körbchen|brust/.test(title)};
   return gs.find(match)||(r.dataset.rnKind==='set'&&kind==='bottom'?gs[1]||null:gs[0]||null);
 }
 const chosen=g=>(g?.querySelector('input[type=radio]:checked')?.value||g?.querySelector('select')?.value||'').trim().toUpperCase();
 function updateHint(r){
   const k=r.dataset.rnKind;
   const top=chosen(group(r,'top'));
   const bottom=chosen(group(r,'bottom'));
   const good=s=>['S','M','L'].includes(s);
   let label='Finde deine passende Grösse';
   if(k==='bh'&&good(top))label=top+' entspricht etwa EU '+sizeToEU[top];
   if(k==='string'&&good(bottom))label=bottom+' entspricht etwa EU '+sizeToEU[bottom];
   if(k==='set')label=(good(top)?'BH '+top:'BH wählen')+' · '+(good(bottom)?'String '+bottom:'String wählen');
   const hint=r.querySelector('[data-rn-hint]');if(hint)hint.textContent=label;
   // Rechts steht ausschliesslich das berechnete Resultat, nie nur die ausgewählte Produktvariante.
 }
 function recommendBH(bust,cup){
   if(!Number.isFinite(bust)||bust<63||bust>92)return{size:'',reason:'outside'};
   const base=bust<=72?0:bust<=86?1:2;
   const extra=cup==='E'?1:(cup==='F'||cup==='G')?2:0;
   const ix=base+extra;
   // Keine L-Empfehlung über der grossen Cup-/Brustumfanggrenze.
   if(ix>2)return{size:'',reason:'outside'};
   return{size:sizes[ix],reason:extra?'cup-adjusted':'standard'};
 }
 function readHip(cm){if(cm>=90&&cm<95)return 'S';if(cm>=95&&cm<100)return'M';if(cm>=100&&cm<=105)return 'L';return '';}
 function calc(r){
   const kind=r.dataset.rnKind;
   const bust=Number(r.querySelector('[data-rn-bust]')?.value ?? 80);
   const cup=cupNames[Number(r.querySelector('[data-rn-cup]')?.value ?? 2)]||'C';
   const hip=Number(r.querySelector('[data-rn-hip]')?.value ?? 98);
   const top=recommendBH(bust,cup);
   const bottom=readHip(hip);
   r.querySelectorAll('input[type=range]').forEach(s=>{
     const min=Number(s.min),max=Number(s.max),v=Number(s.value);
     s.closest('[data-rn-track]')?.style.setProperty('--rn-progress',100*(v-min)/(max-min)+'%');
   });
   const outputs=[['[data-rn-bust-out]',bust+' cm'],['[data-rn-cup-out]',cup],['[data-rn-hip-out]',hip+' cm']];
   for(const [sel,value] of outputs){const element=r.querySelector(sel);if(element)element.textContent=value}
   let result='',note='',valid=false;
   if(kind==='string'){
     valid=Boolean(bottom);
     result=bottom||'Keine passende Grösse S–L';
     note=bottom?'Grösse '+bottom+' · Hüftumfang '+hips[bottom][0]+'–'+hips[bottom][1]+' cm.':'Dein Hüftumfang liegt ausserhalb des aktuell angebotenen Grössenbereichs.';
   } else if(kind==='bh'){
     valid=Boolean(top.size);
     result=top.size||apology;
     note=valid?'Brustumfang '+bust+' cm · Cup '+cup+' · unverbindliche RENISA-Empfehlung '+top.size+'.':'Für diese Brust-/Cup-Kombination liegt keine ausreichend sichere RENISA-Grössenempfehlung vor. Bitte kontaktiere uns für eine Passformberatung.';
   } else {
     valid=Boolean(top.size&&bottom);
     result=valid?'BH '+top.size+' · String '+bottom:'Bitte Grösse prüfen';
     note=valid?'BH '+top.size+' nach Brust und Cup; String '+bottom+' nach Hüftumfang. Beides sind Richtwerte.':'Für mindestens eine Angabe gibt es keine ausreichend sichere Grössenempfehlung. Bitte Passform prüfen.';
   }
   r.dataset.rnTop=top.size||'';
   r.dataset.rnBottom=bottom||'';
   r.dataset.rnValid=String(valid);
   r.querySelector('[data-rn-result]').textContent=result;
   r.querySelector('[data-rn-note]').textContent=note;
   r.querySelector('[data-rn-apply]').disabled=!valid;
   r.querySelector('.rn-guide5__result')?.classList.toggle('is-unavailable',!valid);
   if(r.dataset.rnUserEditing==='yes'){
     const short=r.querySelector('[data-rn-short]');
     if(short)short.textContent=valid?(kind==='string'?bottom:kind==='set'?top.size+'/'+bottom:top.size):'–';
   }
 }
 function selectSize(r,part,size){const g=group(r,part);if(!g||!size)return false;const radio=[...g.querySelectorAll('input[type=radio]')].find(x=>x.value.trim().toUpperCase()===size);
   if(radio){if(radio.disabled||radio.getAttribute('aria-disabled')==='true')return false;radio.click();return true;}
   const select=g.querySelector('select');if(select){const opt=[...select.options].find(x=>x.value.trim().toUpperCase()===size&&!x.disabled);if(!opt)return false;select.value=opt.value;select.dispatchEvent(new Event('change',{bubbles:true}));return true;}return false;
 }
 function initialize(r){if(r.dataset.rnInitialized==='yes')return;r.dataset.rnInitialized='yes';updateHint(r);calc(r);}
 function setTab(r,name){r.querySelectorAll('[data-rn-tab]').forEach(t=>{const active=t.dataset.rnTab===name;t.classList.toggle('is-current',active);t.setAttribute('aria-selected',String(active));});r.querySelectorAll('[data-rn-panel]').forEach(p=>p.hidden=p.dataset.rnPanel!==name);}
 document.addEventListener('click',e=>{
   // Grössentabelle neben der Auswahl öffnet denselben Produktdialog im Tabellen-Tab.
   const sizeGuideLink=e.target.closest('a.rn-product-sizeguide-link');
   if(sizeGuideLink){
      const picker=sizeGuideLink.closest('variant-picker');
      const fit=picker?.nextElementSibling?.matches?.('[data-rn-guide5]')?picker.nextElementSibling:document.querySelector('[data-rn-guide5]');
      const dialog=fit?.querySelector('dialog.rn-guide5__dialog');
      if(dialog){
        e.preventDefault();
        initialize(fit);
        setTab(fit,'table');
        if(!dialog.open)dialog.showModal();
        return;
      }
   }
   const o=e.target.closest('[data-rn-open]');if(o){const r=root(o);if(!r)return;initialize(r);calc(r);setTab(r,'calc');const d=r.querySelector('dialog');if(!d.open)d.showModal();return;}
   const c=e.target.closest('[data-rn-close]');if(c){root(c)?.querySelector('dialog')?.close();return;}
   const tab=e.target.closest('[data-rn-tab]');if(tab){const r=root(tab);if(r)setTab(r,tab.dataset.rnTab);return;}
   const apply=e.target.closest('[data-rn-apply]');if(apply){const r=root(apply);if(!r||r.dataset.rnValid!=='true')return;const k=r.dataset.rnKind;
      let ok=false;if(k==='bh')ok=selectSize(r,'top',r.dataset.rnTop);else if(k==='string')ok=selectSize(r,'bottom',r.dataset.rnBottom);else{const first=selectSize(r,'top',r.dataset.rnTop),second=selectSize(r,'bottom',r.dataset.rnBottom);ok=first&&second;}
      if(ok){const short=r.querySelector('[data-rn-short]');short.textContent=k==='string'?r.dataset.rnBottom:k==='bh'?r.dataset.rnTop:r.dataset.rnTop+'/'+r.dataset.rnBottom;updateHint(r);r.querySelector('dialog').close();}
      else r.querySelector('[data-rn-note]').textContent='Die empfohlene Kombination ist momentan nicht auswählbar. Prüfe die verfügbaren Varianten am Produkt.';
      return;
   }
   const dlg=e.target.closest('dialog.rn-guide5__dialog');if(dlg&&e.target===dlg)dlg.close();
 });
 document.addEventListener('input',e=>{
   if(e.target.matches('[data-rn-bust],[data-rn-cup],[data-rn-hip]')){
     const r=root(e.target);if(!r)return;
     initialize(r);r.dataset.rnUserEditing='yes';calc(r);
   }
 });
 document.addEventListener('change',e=>{
   if(e.target.closest('variant-picker'))roots().forEach(r=>{r.dataset.rnUserEditing='no';updateHint(r)});
 });
 const ready=()=>roots().forEach(initialize);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
 new MutationObserver(mutations=>{if(mutations.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-rn-guide5]')||n.querySelector?.('[data-rn-guide5]')))))ready();}).observe(document.documentElement,{childList:true,subtree:true});
})();